import { TestHookService } from "./test-hook-service";
import app from "../../sdAppModule";
app.service("testHookService", TestHookService);
